import { render, staticRenderFns } from "./SwiperSample.vue?vue&type=template&id=05411146&"
import script from "./SwiperSample.vue?vue&type=script&lang=js&"
export * from "./SwiperSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports